export default __webpack_public_path__ + "static/media/question.e004b4a0.svg";